import React from 'react';

const URL_RE = /(https?:\/\/[^\s<>"']+)/gi;

// Split `text` into strings + <a>…</a> React nodes for any URLs found.
// URLs open in a new tab with noopener/noreferrer.
export function linkify(text) {
    if (!text) return text;
    const s = String(text);
    const parts = [];
    let lastIndex = 0;
    let match;
    URL_RE.lastIndex = 0;
    while ((match = URL_RE.exec(s)) !== null) {
        const start = match.index;
        const end = start + match[0].length;
        if (start > lastIndex) parts.push(s.slice(lastIndex, start));
        // Trim trailing punctuation people commonly put after a URL
        let url = match[0];
        let trail = '';
        while (url && /[.,;:!?)\]]$/.test(url)) {
            trail = url[url.length - 1] + trail;
            url = url.slice(0, -1);
        }
        parts.push(
            <a key={parts.length} href={url} target="_blank" rel="noopener noreferrer"
               className="text-primary underline decoration-primary/40 hover:decoration-primary break-words">
                {url}
            </a>
        );
        if (trail) parts.push(trail);
        lastIndex = end;
    }
    if (lastIndex < s.length) parts.push(s.slice(lastIndex));
    return parts.length ? parts : s;
}
